import { Input } from '@/components/ui/input';

interface RequiredDocumentsSectionProps {
  allDocsList: string[];
  requiredDocuments: string[];
  onToggleDoc: (docName: string) => void;
  showCustomDocInput: boolean;
  setShowCustomDocInput: (show: boolean) => void;
  customDocName: string;
  setCustomDocName: (name: string) => void;
  onAddCustomDoc: () => void;
  error?: string;
}

export function RequiredDocumentsSection({
  allDocsList,
  requiredDocuments,
  onToggleDoc,
  showCustomDocInput,
  setShowCustomDocInput,
  customDocName,
  setCustomDocName,
  onAddCustomDoc,
  error,
}: RequiredDocumentsSectionProps) {
  return (
    <div className="rounded-md border border-gray-200 bg-gray-50/60 p-3">
      <div className="mb-2">
        <p className="text-xs font-semibold text-gray-800">Required Documents *</p>
        {error ? (
          <p className="mt-1 text-xs font-medium text-red-600">{error}</p>
        ) : null}
      </div>
      <div className="flex flex-wrap gap-x-4 gap-y-2 mt-2">
        {allDocsList.map((doc) => {
          const checked = requiredDocuments.includes(doc);
          return (
            <label key={doc} className="flex items-center gap-1.5 text-xs text-gray-700 cursor-pointer select-none">
              <input
                type="checkbox"
                checked={checked}
                onChange={() => onToggleDoc(doc)}
              />
              {doc}
            </label>
          );
        })}
      </div>

      <div className="mt-2.5 flex items-center gap-2">
        {showCustomDocInput ? (
          <>
            <Input
              value={customDocName}
              onChange={(e) => setCustomDocName(e.target.value)}
              placeholder="Document name (e.g. GSTIN)"
              className="h-8 text-xs max-w-[200px]"
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  onAddCustomDoc();
                }
              }}
            />
            <button
              type="button"
              onClick={onAddCustomDoc}
              className="shrink-0 rounded-md border border-gray-300 bg-white px-2 py-1 text-xs font-medium text-gray-700 hover:bg-gray-50"
            >
              Add
            </button>
            <button
              type="button"
              onClick={() => {
                setShowCustomDocInput(false);
                setCustomDocName('');
              }}
              className="text-xs text-gray-500 hover:underline"
            >
              Cancel
            </button>
          </>
        ) : (
          <button
            type="button"
            onClick={() => setShowCustomDocInput(true)}
            className="text-xs font-medium text-brand-700 hover:underline"
          >
            + Others / Custom Document
          </button>
        )}
      </div>
    </div>
  );
}
